const OpenGraph = ({
  description = '',
  image = 'https://www.klaviyo.com/static/klaviyo-social-share-image.jpg',
  locale = 'en_US',
  modifiedTime = '',
  publisher = 'https://www.facebook.com/Klaviyo/',
  siteName = 'Klaviyo',
  title = '',
  twitterCard = 'summary_large_image',
  twitterDescription = '',
  twitterImage = 'https://www.klaviyo.com/static/klaviyo-social-share-image.jpg',
  twitterTitle = '',
  twitterUsername = '@klaviyo',
  url = '',
}) => (
  <>
    <meta property="og:locale" content={locale} />
    <meta property="og:type" content="website" />
    {title ? <meta name="og:title" property="og:title" content={title} /> : null}
    {description ? <meta name="og:description" content={description} /> : null}
    {url ? <meta property="og:url" content={url} /> : null}
    {siteName ? <meta property="og:site_name" content={siteName} /> : null}
    {publisher ? <meta property="article:publisher" content={publisher} /> : null}
    {modifiedTime ? <meta property="article:modified_time" content={modifiedTime} /> : null}
    <meta property="og:image" content={image} />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta property="og:image:type" content="image/jpeg" />

    <meta name="twitter:card" content={twitterCard} />
    {twitterTitle ? <meta name="twitter:title" content={twitterTitle} /> : null}
    {(twitterDescription || description) ? <meta name="twitter:description" content={(twitterDescription || description)} /> : null}
    {twitterImage ? <meta name="twitter:image" content={twitterImage} /> : null}
    {twitterUsername ? <meta name="twitter:site" content={twitterUsername} /> : null}
  </>
);

export default OpenGraph;
